// eslint-disable-next-line no-shadow
export enum ErrorCode {
  USER_ALREADY_EXISTS = "USER_ALREADY_EXISTS",
  PHONE_NUMBER_ALREADY_TAKEN = "PHONE_NUMBER_ALREADY_TAKEN",
  NOT_FOUND = "NOT_FOUND",
  FORBIDDEN = "FORBIDDEN",
}
